import { Transition } from 'types/Transitions';
import { SizeType } from './Canvas';
import { Licenses } from 'types/Licenses';
import { PremiumItemSource } from '../constants';

export enum SceneType {
  EMPTY = 'empty',
  VIDEO = 'video',
  IMAGE = 'image'
}

export enum ScalingType {
  FIT = 'fit',
  FILL = 'fill'
}

export type SceneTransition =
  | (Transition & {
      duration?: number;
    })
  | null;

export type Scene = {
  id: string;
  type: SceneType;
  src?: string;
  processingSrc?: string;
  midResSrc?: string;
  bigResSrc?: string;
  localSrc?: string;
  start: number;
  trimStart: number;
  duration: number;
  maxDuration: number;
  transition: SceneTransition;
  prevTransition?: SceneTransition;
  scalingMode: ScalingType;
  size?: SizeType;
  preprocessed?: boolean;
  uploaded?: boolean;
  license?: Licenses;
  volume?: number;
  uploadTaskId?: string;
  stockVideoDownloadId?: string;
  templateId?: string;
  sourceId?: string;
  source?: PremiumItemSource;
};

export type SceneItem = Omit<Scene, 'start' | 'transition'> & {
  transition: Pick<SceneTransition, 'id' | 'duration'>;
};

export type Scenes = {
  current?: string;
  items: SceneItem[];
};

export type DraggableItem = { type: string; id: string; index: number };

export type TempScene = {
  id: string;
  trimStart: number;
  duration: number;
  fileId: string;
  file?: File;
};

export type TempAudio = {
  name: string;
  trimStart: number;
  trimDuration: number;
};

export type TempScenes = { [key: string]: TempScene };
